export default "/provide-liquidity.c0a8027948b0235a04beace1e7e6bbcf.png";